import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import { WidgetComponent } from '../../dashboards/components/widget-component/widget-component';
import { IColumnDefinition } from '../../common/models/column-definition';
import { MyActivitiesTableHttpService } from '../services/my-activities-table-http.service';
import { MyActivityWidgetItem } from '../models/my-activity-widget-item';
import { MyActivitiesDataHttpService } from '../services/my-activities-data-http';
import { ConfirmationService } from 'primeng/api';
import { map, takeWhile } from 'rxjs';

@Component({
  selector: 'mojo-my-activities-widget',
  templateUrl: './my-activities.component.html'
})
export class MyActivitiesComponent extends WidgetComponent implements OnInit, OnDestroy {
  isAlive = false;

  selectedColumns$: Observable<Array<IColumnDefinition>>;
  activities$: Observable<Array<MyActivityWidgetItem>>;

  private readonly creditorInvoiceActivityType: string = 'Creditor Invoice';

  @Input() creditorInvoicesMode = false;

  constructor(
    protected readonly store: Store<ApplicationState>,
    private readonly tableHttpService: MyActivitiesTableHttpService,
    private readonly dataHttpService: MyActivitiesDataHttpService,
    protected confirmationService: ConfirmationService
  ) {
    super(store, confirmationService);
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  ngOnInit() {
    super.ngOnInit();

    this.isAlive = true;

    this.activities$ = this.dataHttpService
      .getMyActivities().pipe(
        map((all) => {
          return all.filter(item => {
            if (this.creditorInvoicesMode) {
              return (item.ActivityType === this.creditorInvoiceActivityType);
            } else {
              return (item.ActivityType !== this.creditorInvoiceActivityType);
            }
          });
        }),
        takeWhile(() => this.isAlive)
      );

    this.selectedColumns$ = this.tableHttpService
      .getSelectedColumns(this.widget.id).pipe(
        takeWhile(() => this.isAlive)
      );
  }

}
